import React from 'react';
import Banner from './component/banner';
import Approvals from './component/approvals';
import Miniapp from './component/miniapp';
import store from '@/store';

import './index.less';

const Overview: React.FC = () => {
  const [spaceRoleState] = store.useModel('spaceRole');
  return (
    <div className="overview">
      <Banner />
      {spaceRoleState?.roleList?.includes('ADMIN') && spaceRoleState.type === 'CONSUMER' ? <Approvals spaceId={spaceRoleState.spaceId || ''} /> : null}
      <Miniapp />
    </div>
  );
};

export default Overview;
